import { EnumEmailState } from './Generated';
import type { SelectOption } from '@synqo/frontend-component-library';
import type { ApiInvoiceEmailDelivery } from './Generated';

export const emailFailureStates: EnumEmailState[] = [
    EnumEmailState.Suppressed,
    EnumEmailState.Bounced,
    EnumEmailState.Quarantined,
    EnumEmailState.FilteredSpam,
    EnumEmailState.Failure,
];

export const emailPendingStates: EnumEmailState[] = [EnumEmailState.NotStarted, EnumEmailState.Pending];

export function getAggregatedEmailStatus(groupEmails: ApiInvoiceEmailDelivery[]): EnumEmailState {
    if (groupEmails.length === 0) {
        return EnumEmailState.NotStarted;
    }

    for (const email of groupEmails) {
        if (emailFailureStates.includes(email.email_state)) {
            return EnumEmailState.Failure;
        }
    }

    for (const email of groupEmails) {
        if (emailPendingStates.includes(email.email_state)) {
            return EnumEmailState.Pending;
        }
    }

    return groupEmails[0].email_state;
}

export const getEnumEmailStateLabel = (value: EnumEmailState) => {
    switch (value) {
        case EnumEmailState.NotStarted:
            return 'Verarbeitung nicht gestartet';
        case EnumEmailState.Pending:
            return 'In Verarbeitung';
        case EnumEmailState.Success:
            return 'Erfolgreich versendet';
        case EnumEmailState.Failure:
            return 'Versand fehlgeschlagen';
        case EnumEmailState.Canceled:
            return 'Abgebrochen';
        case EnumEmailState.Suppressed:
            return 'Unterdrückt';
        case EnumEmailState.Bounced:
            return 'Zustellung fehlgeschlagen';
        case EnumEmailState.Quarantined:
            return 'In Quarantäne';
        case EnumEmailState.FilteredSpam:
            return 'Als Spam gefiltert';
        default:
            return 'Nicht definiert';
    }
};

export const emailStateOptions: SelectOption<EnumEmailState>[] = [
    {
        name: 'pending',
        label: getEnumEmailStateLabel(EnumEmailState.Pending),
        value: EnumEmailState.Pending,
    },
    {
        name: 'success',
        label: getEnumEmailStateLabel(EnumEmailState.Success),
        value: EnumEmailState.Success,
    },
    {
        name: 'failure',
        label: getEnumEmailStateLabel(EnumEmailState.Failure),
        value: EnumEmailState.Failure,
    },
    {
        name: 'canceled',
        label: getEnumEmailStateLabel(EnumEmailState.Canceled),
        value: EnumEmailState.Canceled,
    },
    {
        name: 'not-started',
        label: getEnumEmailStateLabel(EnumEmailState.NotStarted),
        value: EnumEmailState.NotStarted,
    },
    {
        name: 'suppressed',
        label: getEnumEmailStateLabel(EnumEmailState.Suppressed),
        value: EnumEmailState.Suppressed,
    },
    {
        name: 'bounced',
        label: getEnumEmailStateLabel(EnumEmailState.Bounced),
        value: EnumEmailState.Bounced,
    },
    {
        name: 'quarantined',
        label: getEnumEmailStateLabel(EnumEmailState.Quarantined),
        value: EnumEmailState.Quarantined,
    },
    {
        name: 'filtered-spam',
        label: getEnumEmailStateLabel(EnumEmailState.FilteredSpam),
        value: EnumEmailState.FilteredSpam,
    },
];
